export default __webpack_public_path__ + "static/media/640_dummy2016-allgemeinarzt01-mobile-de.75839ff4.png";